import styled from "styled-components";
const TextLimited = styled.h5`

  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default TextLimited;
